<template>
  <div class="offCanvasAsiakas">
    <v-toolbar
      color="primary"
      class="px-1"
      flat
    >
      <v-btn
        :dark="true"
        icon
        @click="$emit('close-button-click')"
      >
        <v-icon>clear</v-icon>
      </v-btn>

      <v-toolbar-title>
        Asiakkaan tiedot
      </v-toolbar-title>

      <v-spacer />

      <v-tooltip left>
        <template v-slot:activator="{ on }">
          <v-btn
            v-if="(typeof value.id != 'undefined')"
            :dark="true"
            class="white v-btn--has-bg primary--text"
            icon
            :to="{
              name: 'laskutus-asiakas-nayta',
              params: {
                id: value.id,
              },
            }"
            v-on="on"
          >
            <v-icon>open_in_new</v-icon>
          </v-btn>
        </template>
        <template v-slot:default>
          <span>Avaa asiakas</span>
        </template>
      </v-tooltip>
    </v-toolbar>
    <v-container class="grey lighten-5 px-8">
      <OffCanvasDetailsAsiakas v-model="value" />
    </v-container>
    <v-container>
      <AsiakasLaskutuksenYhteenveto
        :asiakas="value"
        class="mt-4 mx-5"
      />
    </v-container>
  </div>
</template>

<script>

import ClickOutside from 'vue-click-outside'
import AsiakasLaskutuksenYhteenveto from '@/components/AsiakasLaskutuksenYhteenveto'
import OffCanvasDetailsAsiakas from '@/components/OffCanvasDetailsAsiakas'

export default {
  name: 'OffCanvasAsiakas',
  directives: {
    ClickOutside,
  },
  components: {
    AsiakasLaskutuksenYhteenveto,
    OffCanvasDetailsAsiakas,
  },
  props: {
    value: {
      type: Object,
      required: false,
      default () {
        return {}
      },
    },
  },
  watch: {
    value: {
      deep: true,
      handler (val) {
        this.$emit('input', val)
      }
    }
  },
}

</script>

<style lang="scss" scoped>

</style>
